import { jsxs, jsx } from 'react/jsx-runtime';
import { useRouter } from '@fabric-app/compat';
import { nativeWindow } from '@todesktop/client-core';
import { publish } from '@todesktop/client-ipc';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { IconMove } from '@fabric-app/icons/svg';
import { resourceMoveModal } from '../../ModalMoveResources/moveResourcesStore.js';

const ContextItemMove = () => {
  const { resource, disabledActions } = useResourceDataContextSafe();
  const router = useRouter();
  const cantMoveReason = disabledActions.move;
  const handleMove = () => {
    if (!resource.id) return;
    if (router.pathname === "/desktop-global-search") {
      try {
        publish("add-to-space", {
          resource
        });
      } catch (_e) {
        window.open(`fabric://add-to-space?id=${resource.id}`, "_blank");
      }
      nativeWindow.close();
      return;
    }
    resourceMoveModal.open({
      resources: [
        resource
      ]
    });
  };
  return /* @__PURE__ */ jsxs(ContextMenu.Item, {
    onClick: handleMove,
    "data-testid": "item-context-menu-add-to-space",
    disabledReason: cantMoveReason,
    children: [
      /* @__PURE__ */ jsx(DropdownItemIconContainer, {
        children: /* @__PURE__ */ jsx(IconMove, {})
      }),
      "Move..."
    ]
  });
};

export { ContextItemMove };
//# sourceMappingURL=ContextItemMove.js.map
